<template>
  <div>
    <div class="grid gap-y-2 gap-x-8 sm:grid-cols-1 md:grid-cols-2">
      <div class="panel">
        <div class="panel-body">
          <liquidations-monthly :data="liquidations_monthly" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <advances-monthly :data="total_advances" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <ok-discard-monthly :data="totals_monthly" />
        </div>
      </div>
      <div class="panel" v-if="Object.keys(crop_sizes).length > 1">
        <div class="panel-body">
          <crop-sizes :data="crop_sizes" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LiquidationsMonthly from "@/components/views/agro_exporter/liquidations/query_by_provider/charts/LiquidationsMonthly.vue";
import AdvancesMonthly from "@/components/views/agro_exporter/liquidations/query_by_provider/charts/AdvancesMonthly.vue";
import OkDiscardMonthly from "@/components/views/agro_exporter/liquidations/query_by_provider/charts/OkDiscardMonthly.vue";
import CropSizes from "@/components/views/agro_exporter/liquidations/query_by_provider/charts/CropSizes.vue";
export default {
  name: "AELiquidationsQueryByProviderShowProviderSummary",
  components: {
    LiquidationsMonthly,
    AdvancesMonthly,
    OkDiscardMonthly,
    CropSizes
  },
  props: {
    provider_id: { required: true },
    provider_type: { required: true },
    agro_exporter_process_id: { required: true },
    liquidations_monthly: { required: true },
    total_advances: { default: 0 },
    totals_monthly: { required: true },
    crop_sizes: { required: true },
  },
  data() {
    return {
    };
  },
  computed: {
  }
};
</script>
